// extracted by mini-css-extract-plugin
export default {"authLayout":"styles_authLayout__ZMNul","authBackground":"styles_authBackground__FKjgQ","authContentBackground":"styles_authContentBackground__CmZGk"};